import { gql } from '@apollo/client';

export const GET_AIR_PRODUCTS = gql`
  query AirProductFindMany($filter: FilterFindManyAirProductInput) {
    airProductFindMany(filter: $filter) {
      jobUrl
      token
      name
      executions {
        status
        reportUrl
        executionStatus
        name
        createDate
        endDate
        testName
      }
      tests {
        name
        createDate
      }
      _id
    }
  }
`;
